export const routes = (prefix = `radiology`) => [
    {
        path: `/${prefix}/record-results/:patientID/:visitNO`,
        name: `${prefix}.record-results.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.record-results.create`,
                PageDescription: `Radiology: Record results.`,
            },
        },
    },
    {
        path: `/${prefix}/record-results/:patientID`,
        name: `${prefix}.record-results.create-past`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.record-results.create`,
                PageDescription: `Radiology: Record results.`,
            },
        },
    },
];